export default __webpack_public_path__ + "static/media/Logo_del_Banco_Ve_por_Más.8ea50da1.png";